import {html} from "@isceco/widget-library2/external/lit";

export default function createProjectNAR(formComponent) {
  return html`
    <isceco-card text="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.title')}"
                 class="form-card">
      <isceco-text-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.subtitle')}"
        name="project.title"
        required
        .readonly="${formComponent.preview}">
      </isceco-text-input>
      <isceco-file-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.upload.antragsformular')}"
        name="project.attachmentRequestForm"
        required
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        maxfiles="1"
        maxsize="${formComponent.fileMaxSize}"
        .fileInputService="${formComponent.fileInputService}"
        .disabled="${formComponent.preview}"
      ></isceco-file-input>
      <isceco-file-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.upload.template')}"
        name="project.attachmentTemplate"
        required
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        maxfiles="1"
        maxsize="${formComponent.fileMaxSize}"
        .fileInputService="${formComponent.fileInputService}"
        .disabled="${formComponent.preview}"
      ></isceco-file-input>
      <isceco-file-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.upload.attachments')}"
        name="project.attachments"
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        multiple
        maxfiles="25"
        maxsize="${formComponent.fileMaxSize}"
        .fileInputService="${formComponent.fileInputService}"
        .disabled="${formComponent.preview}"
      ></isceco-file-input>
      <isceco-textarea label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project3.note')}"
                       name="project.note"
                       rows="4"
                       .readonly="${formComponent.preview}"
      ></isceco-textarea>
    </isceco-card>`
}
